<template>
  <div class="page">
    <wk-search class="wrapBox" :search-control-data="searchControlData" @search="search($event)"></wk-search>
    <black-export v-auth="permission.APPLICATION_PRE_AUDIT_EXPORT" class="wrapBox" @export="exportClick($event)"></black-export>
    <div class="wrapBox">
      <div class="flex justify-space-between" style="margin-bottom: 10px">
        <div class="line-40">共{{ total }}条数据</div>
      </div>
      <el-table  v-auth="permission.APPLICATION_PRE_AUDIT_LIST" class="tableBox W100" :data="tableData" stripe>
        <el-table-column fixed align="center" width="60" type="index" label="序号"></el-table-column>
        <el-table-column fixed prop="apkName" label="应用名称"></el-table-column>
        <el-table-column fixed prop="apkIcon" label="ICON">
          <template slot-scope="scope">
            <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.apkIcon"
                fit="fit"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="apkPackage" label="应用包名"></el-table-column>
        <el-table-column prop="createTime" label="提交预审时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state == 1" type="info">待审核</el-tag>
            <el-tag v-if="scope.row.state == 2" type="success">已通过</el-tag>
            <el-tag v-if="scope.row.state == 3" type="danger">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pretrialTime" label="审核时间">
          <template slot-scope="scope">
            <span>{{ scope.row.pretrialTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="accountId" label="开发者ID"></el-table-column>
        <el-table-column prop="companyName" label="企业名称"></el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="120"
        >
          <template slot-scope="scope">
            <el-button
                v-auth="permission.APPLICATION_PRE_AUDIT_APPROVE"
                v-if="scope.row.state == 1"
                class="color-blue link-button"
                type="text"
                @click="handleModify(scope.row,'approve')">
              审核
            </el-button>
            <el-button
                v-else
                class="color-blue link-button"
                type="text"
                @click="handleModify(scope.row,'view')">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchFormData.perPage"
            :current-page="searchFormData.page"
            layout="total, prev, pager, next, sizes"
            :total="total"
        ></el-pagination>
      </div>
    </div>
    <modifyDialog ref="dialog" @refresh="search()"></modifyDialog>
  </div>
</template>
<script>
import modifyDialog from "./components/modifyDialog";
import BlackExport from './components/blackExport';
import store from '@/store/index.js';

export default {
  beforeRouteEnter: (to, from, next) => {
    store.commit("breadcrumbStore/setMenuBreadcrumb", {
      'menu': to.meta.menuBreadcrumb,
      name: "应用预审核",
      path: to.fullPath
    });
    next()
  },
  components: {modifyDialog, BlackExport},
  data() {
    return {
      //搜索form组件
      searchControlData: [
        {
          type: "input",
          label: "应用名称",
          placeholder: "应用名称",
          key: "apkName"
        },
        {
          type: "input",
          label: "应用包名",
          placeholder: "应用包名",
          key: "apkPackage"
        },
        {
          type: "input",
          label: "开发者ID",
          placeholder: "开发者ID",
          key: "accountId"
        },
        {
          type: "input",
          label: "注册邮箱",
          placeholder: "注册邮箱",
          key: "email"
        },
        {
          type: 'select',
          label: '状态',
          placeholder: '请选择状态',
          key: 'state',
          option: [
            {
              label: '全部',
              value: ''
            },
            {
              label: '待审核',
              value: '1'
            },
            {
              label: '已通过',
              value: '2'
            },
            {
              label: '未通过',
              value: '3'
            },
          ]
        },
      ],
      //列表数据
      tableData: [],
      total: 0,
      //搜索form数据
      searchFormData: {
        page: 1,
        perPage: 10
      },
    };
  },

  created() {
    this.search();
  },
  methods: {
    //搜索方法
    search(data) {
      if (data) {
        this.searchFormData = {
          page: 1,
          perPage: this.searchFormData.perPage,
          ...data
        };
      }
      this.$apis.preAuditServer.queryList(this.searchFormData).then(res => {
        if (res['code'] == 0 && res.data.data) {
          this.total = res.data.total;
          this.tableData = res.data.data;
        } else {
          this.total = 0;
          this.tableData = [];
        }
      });
    },
    //导出方法
    exportClick(data) {
      //时间范围组件 取开始结束时间
      data.startTime = data.time ? data.time[0] : "";
      data.endTime = data.time ? data.time[1] : "";
      this.$apis.preAuditServer.exportIdentify(data).then(res => {
        if (res['code'] == 0 && res.data.link) {
          let link = res.data.link;
          window.location.href = link;
        } else {
          this.$message({
            message: "失败",
            type: "error"
          });
        }
      });
    },
    //点击编辑
    handleModify(row, type) {
      this.$refs["dialog"].showDialog(row, type);
    },
    //table点击更改一页多少行
    handleSizeChange(val) {
      this.searchFormData.perPage = val;
      this.search();
    },
    //table点击修改页码
    handleCurrentChange(val) {
      this.searchFormData.page = val;
      this.search();
    },
  }
};
</script>
<style scoped lang="scss">
/deep/ .el-message-box--center .el-message-box__message {
  font-size: 20px;
}
</style>
